'use strict';
import analytics from './analytics';
import util from './util';
import currentLayout from './detect-layout';
import recommendationsCarousel from './pages/product/recommendationsCarousel';
 let currLayoutVal = currentLayout.init();

let minSlides = 2;
if(currLayoutVal === 'desktop') minSlides = 4;

const collectionRange = {
    init: function () {
        const $slider = $('.js-range-slider');
        if (!$slider.length || $slider.find('.range-tile').length < minSlides || $slider.hasClass('slick-initialized')) {
            return;
        }
        $slider.on('init afterChange', function () {
            setTimeout(function () {
                $slider.find('.range-tile').removeAttr('tabindex');
                $('.range-arrow').attr('tabindex', '-1');
            }, 0);
        });

        $slider.slick({
            slidesToShow: 3.5,
            slidesToScroll: 1,
            infinite: false,
            swipeToSlide: true,
            swipe: true,
            dots: false,
            arrows: true,
            draggable: true,
            touchMove: true,
            prevArrow: $('.range-arrow--prev'),
            nextArrow: $('.range-arrow--next'),
            accessibility: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.13,
                        centerMode: true,
                        centerPadding: '20px',
                    }
                }
            ]
        });
 
        $(window).on('resize', updateAccordionState);
        updateAccordionState();
        collectionAccordionEventsHandler();
        initBVAccessibilityObserver();
    }
};

function updateAccordionState() {
    const desktop = window.matchMedia('(min-width: 1024px)').matches;

    $('.star-product').each(function () {
        let $button = $(this).find('.star-product__toggle');
        let $panel = $(this).find('.star-product__content-wrapper');

        if (desktop) {
            $button.attr('aria-expanded', 'true').attr('tabindex', '-1');
            $panel.prop('hidden', false);
        } else {
            $button.removeClass('ui-accordion-header-active').attr('aria-expanded', 'false');
            $panel.prop('hidden', true);
        }
    });
}

function collectionAccordionEventsHandler() {
    $('.star-product__toggle').off().on('click',function (e) {
        e.preventDefault();
        let $button = $(this);
        let $panel = $('#' + $button.attr('aria-controls'));
        let expanded = $button.attr('aria-expanded') === 'true';
    
        $button.toggleClass('ui-accordion-header-active', !expanded).attr('aria-expanded', !expanded);
        $panel.prop('hidden', expanded);
    });
}

function updateHeaderBackground($tile) {
    const desktop = $tile.data('bg-image');
    const mobile = $tile.data('bg-image-mobile');
    const $picture = $('.collection-header__background picture');

    $picture.find('source[media="(max-width: 768px)"]')
        .attr('srcset', mobile);

    $picture.find('source[media="(min-width: 769px)"]')
        .attr('srcset', desktop);

    $picture.find('.collection-header__bg-image')
        .attr('src', desktop);
}

function initBVAccessibilityObserver() {
    const container = document.querySelector('.collection-bottom');
    if (!container) return;
    // Handle existing link
    $(container).find('.bv-rating-wrapper a').attr('tabindex', '-1');

    const observer = new MutationObserver(function () {
        $(container).find('.bv-rating-wrapper a').attr('tabindex', '-1');
    });
    observer.observe(container, {
        childList: true,
        subtree: true
    });
}

function renderCarouselTiles (cgid, $selectedTile, totalSlides, index)  {
    $.ajax({
        url: util.appendParamToURL(Urls.GetRangeData, 'cgid', cgid),
        method: 'GET'
    })
    .done(function (response) { 
         if (response) {
            const $collectionBottom = $('.collection-bottom');
            $collectionBottom.html(response);
            $('.range-tile').removeClass('range-tile--active').removeAttr('aria-current');
            $selectedTile.addClass('range-tile--active').attr('aria-current', 'page');
            recommendationsCarousel.init();
            analytics.collectionPageCrosssellafterInit();
            analytics.collectionPageCrosssellClick();
            
            if (totalSlides) {
                if(totalSlides -1 == index) {
                    $('.collection-range-carousel').addClass('last-slide');
                } else {
                    $('.collection-range-carousel').removeClass('last-slide');
                }
            }
        }
    });
}

$('.pt_collectionrange').on('click', '.js-range-slider .range-tile', function(e) {
    e.preventDefault();
    const $this = $(this);
    if($this.hasClass('range-tile--active')) {
        return;
    }
    const $rangeSlider = $('.js-range-slider');
    let totalSlides;
    let index;

    if ($rangeSlider.find('.range-tile').length >= minSlides) {
        const slideIndex = $this.closest('.slick-slide').data('slick-index');
        totalSlides = $rangeSlider.find('.slick-slide').length;
        index = parseInt(slideIndex, 10);
        $rangeSlider.slick('slickGoTo', index - Math.floor($rangeSlider.slick('slickGetOption', 'slidesToShow') / 2));
    }

    updateHeaderBackground($this);
    analytics.trackCollectionClick($this);
    renderCarouselTiles($this.data('cgid'), $this, totalSlides, index);
});

export default collectionRange;